export default __webpack_public_path__ + "static/media/team4.a3071de2.png";